import { ChevronRight, CirclePlus, CalendarSearch } from 'lucide-react';
import { Link } from 'react-router-dom';

import WeekdaysSelected from './components/listOfferingSessionRuleSetsForOffering/WeekdaysSelected';
import { formatLocalDate } from '@/helpers/dateHelpers';
import { Button } from '@/components/ui/button';
import Spinner from '@/components/common/Spinner';
import { Empty, EmptyIcon, EmptyTitle } from '@/components/ui/empty';

import { useOfferingSessionRuleSets } from '@/data/offeringSessionRuleSet';

const ListOfferingRuleSetsForOfferingCard = ({ offeringId }) => {
  const offeringSessionRuleSets = useOfferingSessionRuleSets(offeringId);

  if (offeringSessionRuleSets.isLoading && !offeringSessionRuleSets.data) {
    return (
      <div className="flex justify-center items-center h-18">
        <Spinner />
      </div>
    );
  }

  if (offeringSessionRuleSets.data.length === 0) {
    return (
      <Empty>
        <EmptyIcon>
          <CalendarSearch />
        </EmptyIcon>
        <EmptyTitle>No Availabilities Found</EmptyTitle>
        <div className="flex justify-center">
          <Link asChild to={`/offering-session-rule-set/${offeringId}/add`}>
            <Button variant="ghost" size="sm" className="flex gap-1 text-xs">
              <CirclePlus size={16} />
              Add Date Range
            </Button>
          </Link>
        </div>
      </Empty>
    );
  }

  return (
    <div className="space-y-4">
      {offeringSessionRuleSets.data.map((offeringSessionRuleSet) => (
        <div
          key={offeringSessionRuleSet.id}
          className="flex items-center justify-between mb-4"
        >
          <div>
            <span className="text-sm text-muted-foreground mb-2 block">
              {formatLocalDate(offeringSessionRuleSet.startDate)} -{' '}
              {formatLocalDate(offeringSessionRuleSet.endDate)}
            </span>
            <WeekdaysSelected
              selectedDays={offeringSessionRuleSet.daysOfWeek}
            />
          </div>
          <Link
            to={`/offering-session-rule-set/${offeringId}/edit/${offeringSessionRuleSet.id}`}
          >
            <Button variant="ghost" size="sm" className="flex gap-1">
              Edit
              <ChevronRight />
            </Button>
          </Link>
        </div>
      ))}
      <div className="flex justify-center">
        <Link asChild to={`/offering-session-rule-set/${offeringId}/add`}>
          <Button variant="ghost" size="sm" className="flex gap-1 text-xs">
            <CirclePlus size={16} />
            Add New Date Range
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ListOfferingRuleSetsForOfferingCard;
